module.exports = __webpack_public_path__ + "media/08 Solstice.e696df82.mp3";